const dig = (object, tag) => {
  try {
    return object[tag]
  } catch {
    return null
  }
}

export default dig
